export const bluetooth = {
  name: "bluetooth" as const,
  svg: `<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor"><path fill-rule="evenodd" d="M11.61 3.189a.9.9 0 0 1 .952.108l5 4a.9.9 0 0 1 0 1.406L13.441 12l4.121 3.297a.9.9 0 0 1 0 1.406l-5 4A.9.9 0 0 1 11.1 20v-6.127l-3.538 2.83a.9.9 0 0 1-1.124-1.406L10.559 12 6.438 8.703a.9.9 0 1 1 1.124-1.406l3.538 2.83V4a.9.9 0 0 1 .51-.811Zm1.29 10.684L15.56 16l-2.66 2.127v-4.254Zm0-3.746V5.873L15.56 8l-2.66 2.127Z" clip-rule="evenodd"/></svg>`,
  keywords: ["bluetooth"],
  category: "device" as const,
};
